/**
 * Compatibility shim — legacy pages still import this, but the real
 * layout (sidebar + topbar + page padding) is now provided by
 * shell/DashboardShell.js mounted in App.js. This component therefore
 * just renders its children straight through.
 */

import PropTypes from "prop-types";
import Box from "@mui/material/Box";

function DashboardLayout({ children }) {
  return <Box>{children}</Box>;
}

DashboardLayout.propTypes = { children: PropTypes.node.isRequired };

export default DashboardLayout;
